import { render, staticRenderFns } from "./RegionalConfiguradaComponent.vue?vue&type=template&id=4bb553b2"
import script from "./RegionalConfiguradaComponent.vue?vue&type=script&lang=js"
export * from "./RegionalConfiguradaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports